/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lms-yard-local',
  templateUrl: './yard-local.component.html',
  styleUrls: ['./yard-local.component.scss']
})
export class YardLocalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
